import { forwardRef } from 'react';
import MuiButton from '@mui/material/Button';
import colors from '../../assets/colors';
import { styled } from '@mui/system';

const StyledButton = styled(MuiButton, {
  shouldForwardProp: (prop) => prop !== 'login' && prop !== 'red',
})(({ theme, login, red }) => ({
  ...(login && {
    border: `2px solid ${colors.agroweGreen}`,
    boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2)',
    borderRadius: '13px',
    color: colors.agroweGreen,
    fontSize: '34px',
    letterSpacing: '0.25px',
    textTransform: 'none',
    '&:hover': {
      border: `2px solid ${colors.agroweGreen}`,
      boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2)',
      filter:
        'drop-shadow(0px 6px 10px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 18px rgba(0, 0, 0, 0.12))',
    },
  }),
  ...(red && {
    color: colors.redButton,
    borderColor: colors.redButton,
    '&:hover': {
      borderColor: colors.redButton,
    },
  }),
  ...(!login &&
    !red && {
      padding: '15px 32px',
      marginBottom: 15,
      textTransform: 'none',
      fontWeight: theme.typography.fontWeightBold,
      overflowWrap: 'anywhere',
      hyphens: 'auto',
      '&.MuiButton-label': {
        color: colors.white,
        fontSize: '0.9375rem',
        fontWeight: theme.typography.fontWeightSemiBold,
        letterSpacing: '0.71px',
        lineHeight: '1.625rem',
        textTransform: 'none',
      },
      '&.MuiButton-contained': {
        backgroundColor: colors.oldAgroweGreen,

        '&:hover': {
          opacity: 0.8,
          backgroundColor: colors.oldAgroweGreen,
        },

        '&.Mui-disabled': {
          backgroundColor: colors.disabledButton,

          '& .MuiButton-label': {
            color: colors.black,
          },
          '& .MuiButton-endIcon ': {
            opacity: 0.3,
          },
        },
      },
      '&.MuiButton-outlined': {
        border: '2px solid rgba(251,251,220,0.16)',

        '& .MuiButton-label': {
          color: 'rgba(251,251,220,0.4)',
        },

        '&:hover': {
          backgroundColor: 'rgba(251,251,220,0.15)',
        },
      },
      '&.MuiButton-startIcon': {
        left: 38,
        position: 'absolute',
      },
    }),
}));

const Button = forwardRef((props, ref) => {
  const { children, classes: cls, ...rest } = props;
  return (
    <StyledButton
      ref={ref}
      classes={{
        ...cls,
      }}
      {...rest}
    >
      {children}
    </StyledButton>
  );
});

export default Button;
